<div class="align-center nova-font-style">
  <div>
    <img src="assets/img/Maryland crab.jpg" class="crab-img" alt="Maryland Crab">
    <div class="img-subtitle">
      <div class="align-center">
        <span>{{message}}</span>
      </div>
    </div>
  </div>
</div>
